import URLSearchParams from "url-search-params";

// set URLSearchParams only if not defined natively
if (!window.URLSearchParams)
  window.URLSearchParams = URLSearchParams;



// WEBPACK FOOTER //
// ./_polyfill/url-search-params.js